import { render, staticRenderFns } from "./GeneratePortfolioView.vue?vue&type=template&id=4539434b&scoped=true&"
import script from "./GeneratePortfolioView.vue?vue&type=script&lang=js&"
export * from "./GeneratePortfolioView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4539434b",
  null
  
)

export default component.exports